export const APP_STARTED = 'APP_STARTED';
export const SET_UNIQUE_EMBED_ID = 'SET_UNIQUE_EMBED_ID';
export const SET_SOURCE_APP = 'SET_SOURCE_APP';
export const SET_EMAIL_SENDING_APP_ID = 'SET_EMAIL_SENDING_APP_ID';
export const SET_EMPTY_STATE_NAME = 'SET_EMPTY_STATE_NAME';
export const SET_IS_SIMPLE_CONFIG_PANEL = 'SET_IS_SIMPLE_CONFIG_PANEL';
export const REQUESTED_WORKFLOWS = 'REQUESTED_WORKFLOWS';
export const RECEIVED_WORKFLOWS = 'RECEIVED_WORKFLOWS';
export const RECEIVED_DELETED_WORKFLOWS = 'RECEIVED_DELETED_WORKFLOWS';
export const WORKFLOWS_REQUEST_FAILED = 'WORKFLOWS_REQUEST_FAILED';
export const REQUESTED_EMAIL_PORTAL_STATUS = 'REQUESTED_EMAIL_PORTAL_STATUS';
export const RECEIVED_EMAIL_PORTAL_STATUS = 'RECEIVED_EMAIL_PORTAL_STATUS';
export const REQUESTED_EMAIL_PORTAL_STATUS_FAILED = 'REQUESTED_EMAIL_PORTAL_STATUS_FAILED';
export const REQUESTED_EMAIL_PERFORMANCE = 'REQUESTED_EMAIL_PERFORMANCE';
export const RECEIVED_EMAIL_PERFORMANCE = 'RECEIVED_EMAIL_PERFORMANCE';
export const REQUESTED_EMAIL_PERFORMANCE_FAILED = 'REQUESTED_EMAIL_PERFORMANCE_FAILED';
export const REQUESTED_EMAIL_PERFORMANCE_OVER_TIME = 'REQUESTED_EMAIL_PERFORMANCE_OVER_TIME';
export const RECEIVED_EMAIL_PERFORMANCE_OVER_TIME = 'RECEIVED_EMAIL_PERFORMANCE_OVER_TIME';
export const REQUESTED_EMAIL_PERFORMANCE_OVER_TIME_FAILED = 'REQUESTED_EMAIL_PERFORMANCE_OVER_TIME_FAILED';
export const REQUESTED_ASSIGNABLE_USERS = 'REQUESTED_ASSIGNABLE_USERS';
export const RECEIVED_ASSIGNABLE_USERS = 'RECEIVED_ASSIGNABLE_USERS';
export const REQUESTED_ASSIGNABLE_USERS_FAILED = 'REQUESTED_ASSIGNABLE_USERS_FAILED';
export const REQUESTED_TEAMS = 'REQUESTED_TEAMS';
export const RECEIVED_TEAMS = 'RECEIVED_TEAMS';
export const REQUESTED_BULK_ENROLLMENTS = 'REQUESTED_BULK_ENROLLMENTS';
export const RECEIVED_BULK_ENROLLMENTS = 'RECEIVED_BULK_ENROLLMENTS';
export const REQUESTED_DEAL_PIPELINES = 'REQUESTED_DEAL_PIPELINES';
export const RECEIVED_DEAL_PIPELINES = 'RECEIVED_DEAL_PIPELINES';
export const REQUESTED_DEAL_PROPERTIES = 'REQUESTED_DEAL_PROPERTIES';
export const RECEIVED_DEAL_PROPERTIES = 'RECEIVED_DEAL_PROPERTIES';
export const DEAL_PROPERTIES_REQUEST_FAILED = 'DEAL_PROPERTIES_REQUEST_FAILED';
export const REQUESTED_DEAL_PROPERTY_REQUIREMENTS = 'REQUESTED_DEAL_PROPERTY_REQUIREMENTS';
export const RECEIVED_DEAL_PROPERTY_REQUIREMENTS = 'RECEIVED_DEAL_PROPERTY_REQUIREMENTS';
export const DEAL_PROPERTY_REQUIREMENTS_REQUEST_FAILED = 'DEAL_PROPERTY_REQUIREMENTS_REQUEST_FAILED';
export const REQUESTED_PROPERTIES = 'REQUESTED_PROPERTIES';
export const RECEIVED_PROPERTIES = 'RECEIVED_PROPERTIES';
export const REQUESTED_PROPERTIES_FAILED = 'REQUESTED_PROPERTIES_FAILED';
export const REQUESTED_CONTACT_PROPERTY_REQUIREMENTS = 'REQUESTED_CONTACT_PROPERTY_REQUIREMENTS';
export const RECEIVED_CONTACT_PROPERTY_REQUIREMENTS = 'RECEIVED_CONTACT_PROPERTY_REQUIREMENTS';
export const CONTACT_PROPERTY_REQUIREMENTS_REQUEST_FAILED = 'CONTACT_PROPERTY_REQUIREMENTS_REQUEST_FAILED';
export const REQUESTED_COMPANY_PROPERTIES = 'REQUESTED_COMPANY_PROPERTIES';
export const RECEIVED_COMPANY_PROPERTIES = 'RECEIVED_COMPANY_PROPERTIES';
export const COMPANY_PROPERTIES_REQUEST_FAILED = 'COMPANY_PROPERTIES_REQUEST_FAILED';
export const REQUESTED_COMPANY_PROPERTY_REQUIREMENTS = 'REQUESTED_COMPANY_PROPERTY_REQUIREMENTS';
export const RECEIVED_COMPANY_PROPERTY_REQUIREMENTS = 'RECEIVED_COMPANY_PROPERTY_REQUIREMENTS';
export const COMPANY_PROPERTY_REQUIREMENTS_REQUEST_FAILED = 'COMPANY_PROPERTY_REQUIREMENTS_REQUEST_FAILED';
export const REQUESTED_ENGAGEMENT_PROPERTIES = 'REQUESTED_ENGAGEMENT_PROPERTIES';
export const RECEIVED_ENGAGEMENT_PROPERTIES = 'RECEIVED_ENGAGEMENT_PROPERTIES';
export const ENGAGEMENT_PROPERTIES_REQUEST_FAILED = 'ENGAGEMENT_PROPERTIES_REQUEST_FAILED';
export const REQUESTED_LINE_ITEM_PROPERTIES = 'REQUESTED_LINE_ITEM_PROPERTIES';
export const RECEIVED_LINE_ITEM_PROPERTIES = 'RECEIVED_LINE_ITEM_PROPERTIES';
export const LINE_ITEM_PROPERTIES_REQUEST_FAILED = 'LINE_ITEM_PROPERTIES_REQUEST_FAILED';
export const REQUESTED_EMAIL_PREVIEW = 'REQUESTED_EMAIL_PREVIEW';
export const RECEIVED_EMAIL_PREVIEW = 'RECEIVED_EMAIL_PREVIEW';
export const EMAIL_PREVIEW_REQUEST_FAILED = 'EMAIL_PREVIEW_REQUEST_FAILED';
export const REQUESTED_LOG_EVENTS = 'REQUESTED_LOG_EVENTS';
export const RECEIVED_LOG_EVENTS = 'RECEIVED_LOG_EVENTS';
export const REQUESTED_LOG_EVENTS_FAILED = 'REQUESTED_LOG_EVENTS_FAILED';
export const RECEIVED_LOG_EVENT_CONTACTS = 'RECEIVED_LOG_EVENT_CONTACTS';
export const RECEIVED_LOG_EVENTS_ACTIVE_CONTACTS = 'RECEIVED_LOG_EVENTS_ACTIVE_CONTACTS';
export const ADDED_ALERT = 'ADDED_ALERT';
export const REMOVED_ALERT = 'REMOVED_ALERT';
export const DISMISSED_FIRE_ALARM = 'DISMISSED_FIRE_ALARM';
export const DISMISSED_MESSAGE = 'DISMISSED_MESSAGE';
export const REQUESTED_PORTAL_WORKFLOW_LIMITS = 'REQUESTED_PORTAL_WORKFLOW_LIMITS';
export const RECEIVED_PORTAL_WORKFLOW_LIMITS = 'RECEIVED_PORTAL_WORKFLOW_LIMITS';
export const PORTAL_WORKFLOW_LIMITS_REQUEST_FAILED = 'PORTAL_WORKFLOW_LIMITS_REQUEST_FAILED';
export const REQUESTED_EMAIL_BENCHMARK = 'REQUESTED_EMAIL_BENCHMARK';
export const RECEIVED_EMAIL_BENCHMARK = 'RECEIVED_EMAIL_BENCHMARK';
export const REQUESTED_EMAIL_BENCHMARK_FAILED = 'REQUESTED_EMAIL_BENCHMARK_FAILED';
export const REQUESTED_TICKET_PROPERTIES = 'REQUESTED_TICKET_PROPERTIES';
export const RECEIVED_TICKET_PROPERTIES = 'RECEIVED_TICKET_PROPERTIES';
export const TICKET_PROPERTIES_REQUEST_FAILED = 'TICKET_PROPERTIES_REQUEST_FAILED';
export const REQUESTED_TICKET_PROPERTY_REQUIREMENTS = 'REQUESTED_TICKET_PROPERTY_REQUIREMENTS';
export const RECEIVED_TICKET_PROPERTY_REQUIREMENTS = 'RECEIVED_TICKET_PROPERTY_REQUIREMENTS';
export const TICKET_PROPERTY_REQUIREMENTS_REQUEST_FAILED = 'TICKET_PROPERTY_REQUIREMENTS_REQUEST_FAILED';
export const REQUESTED_QUOTE_PROPERTIES = 'REQUESTED_QUOTE_PROPERTIES';
export const RECEIVED_QUOTE_PROPERTIES = 'RECEIVED_QUOTE_PROPERTIES';
export const QUOTE_PROPERTIES_REQUEST_FAILED = 'QUOTE_PROPERTIES_REQUEST_FAILED';
export const REQUESTED_TICKET_PIPELINES = 'REQUESTED_TICKET_PIPELINES';
export const RECEIVED_TICKET_PIPELINES = 'RECEIVED_TICKET_PIPELINES';
export const REQUESTED_TICKET_PIPELINES_FAILED = 'REQUESTED_TICKET_PIPELINES_FAILED';
export const REQUESTED_CURRENCY_CODES = 'REQUESTED_CURRENCY_CODES';
export const RECEIVED_CURRENCY_CODES = 'RECEIVED_CURRENCY_CODES';
export const REQUESTED_CURRENCY_CODES_FAILED = 'REQUESTED_CURRENCY_CODES_FAILED';
export const REQUESTED_SUBSCRIPTION_GROUPS = 'REQUESTED_SUBSCRIPTION_GROUPS';
export const RECEIVED_SUBSCRIPTION_GROUPS = 'RECEIVED_SUBSCRIPTION_GROUPS';
export const REQUESTED_SUBSCRIPTION_GROUPS_FAILED = 'REQUESTED_SUBSCRIPTION_GROUPS_FAILED';
export const REQUESTED_EXPERIMENT_TREATMENT = 'REQUESTED_EXPERIMENT_TREATMENT';
export const RECEIVED_EXPERIMENT_TREATMENT = 'RECEIVED_EXPERIMENT_TREATMENT';
export const REQUESTED_EXPERIMENT_TREATMENT_FAILED = 'REQUESTED_EXPERIMENT_TREATMENT_FAILED';

// PLATFORM FLOWS APPLICATION
export const SET_CANVAS_VIRTUAL_RENDERING = 'SET_CANVAS_VIRTUAL_RENDERING';
export const ADD_FLOW_ENABLE_ERRORS = 'ADD_FLOW_ENABLE_ERRORS';
export const REMOVE_FLOW_ENABLE_ERRORS = 'REMOVE_FLOW_ENABLE_ERRORS';
export const TEST_FLOW_WITH_OBJECT = 'TEST_FLOW_WITH_OBJECT';
export const HIGHLIGHT_ACTIONS = 'HIGHLIGHT_ACTIONS';
export const REQUESTED_TEAMS_FAILED = 'REQUESTED_TEAMS_FAILED';
export const REQUESTED_USERS_FAILED = 'REQUESTED_USERS_FAILED';
export const REQUESTED_USERS_WITH_PHONE_NUMBER_FAILED = 'REQUESTED_USERS_WITH_PHONE_NUMBER_FAILED';
export const REQUESTED_DEAL_PIPELINES_FAILED = 'REQUESTED_DEAL_PIPELINES_FAILED';
export const SET_BULK_PROCESSING_STATUS = 'SET_BULK_PROCESSING_STATUS';
export const SET_BULK_PROCESSING_POLLING_STATUS = 'SET_BULK_PROCESSING_POLLING_STATUS';
export const ADS_REQUESTED_AD_ACCOUNTS = 'ADS_REQUESTED_AD_ACCOUNTS';
export const ADS_RECEIVED_AD_ACCOUNTS = 'ADS_RECEIVED_AD_ACCOUNTS';
export const ADS_REQUESTED_AD_ACCOUNTS_FAILED = 'ADS_REQUESTED_AD_ACCOUNTS_FAILED';
export const ADS_REQUESTED_AUDIENCE_USAGE = 'ADS_REQUESTED_AUDIENCE_USAGE';
export const ADS_RECEIVED_AUDIENCE_USAGE = 'ADS_RECEIVED_AUDIENCE_USAGE';
export const ADS_REQUESTED_AUDIENCE_USAGE_FAILED = 'ADS_REQUESTED_AUDIENCE_USAGE_FAILED';
export const ADS_CREATE_WORKFLOW_AUDIENCE_REQUESTED = 'ADS_CREATE_WORKFLOW_AUDIENCE_REQUESTED';
export const ADS_CREATE_WORKFLOW_AUDIENCE_SUCCEEDED = 'ADS_CREATE_WORKFLOW_AUDIENCE_SUCCEEDED';
export const ADS_CREATE_WORKFLOW_AUDIENCE_FAILED = 'ADS_CREATE_WORKFLOW_AUDIENCE_FAILED';
export const REQUESTED_DELAYED_OBJECTS = 'REQUESTED_DELAYED_OBJECTS';
export const RECEIVED_DELAYED_OBJECTS = 'RECEIVED_DELAYED_OBJECTS';
export const REQUESTED_DELAYED_OBJECTS_FAILED = 'REQUESTED_DELAYED_OBJECTS_FAILED';
export const CLEAR_DELAYED_OBJECTS = 'CLEAR_DELAYED_OBJECTS';
export const MARK_OBJECTS_AS_UNENROLLED = 'MARK_OBJECTS_AS_UNENROLLED';
export const LOCAL_STORAGE_MERGE_DEEP = 'LOCAL_STORAGE_MERGE_DEEP';
export const REMOVE_QUERY_PERSIST_BY_REGEX = 'REMOVE_QUERY_PERSIST_BY_REGEX';
export const REMOVE_QUERY_PERSIST = 'REMOVE_QUERY_PERSIST';
export const SET_QUERY_PERSIST = 'SET_QUERY_PERSIST';
export const UPDATE_FLOW_LOCALLY = 'UPDATE_FLOW_LOCALLY';
export const REVERT_STAGED_CHANGES = 'REVERT_STAGED_CHANGES';
export const SET_AI_GENERATED_ACTIONS = 'SET_AI_GENERATED_ACTIONS';
export const SET_AI_GENERATED_ENROLLMENT = 'SET_AI_GENERATED_ENROLLMENT';
export const SET_AI_ACTIONS_PROMPT = 'SET_AI_ACTIONS_PROMPT';
export const SET_RESOLUTION_MODE = 'SET_RESOLUTION_MODE';
export const CLOSED_ACTION_CONFIG_RELAXED_VALIDATION = 'CLOSED_ACTION_CONFIG_RELAXED_VALIDATION';
export const OPENED_ACTION_CONFIG_RELAXED_VALIDATION = 'OPENED_ACTION_CONFIG_RELAXED_VALIDATION';
export const ACTION_PANEL_SET_SELECTED_ACTION_SUGGESTION = 'ACTION_PANEL_SET_SELECTED_ACTION_SUGGESTION';
export const ACTION_PANEL_SET_QUEUED_ACTION = 'ACTION_PANEL_SET_QUEUED_ACTION';
export const ACTION_PANEL_RESET_SUGGESTIONS = 'ACTION_PANEL_RESET_SUGGESTIONS';
export const MENU_BAR_SET_OPEN_ID = 'MENU_BAR_SET_OPEN_ID';
export const MENU_BAR_SET_IS_ACTIVE = 'MENU_BAR_SET_IS_ACTIVE';
export const MENU_BAR_SET_MODAL_STATE_BY_ID = 'MENU_BAR_SET_MODAL_STATE';

// ############################################
// CLASSIC DEPRECATED RESOURCE ACTION TYPES
// ############################################

export const REQUESTED_PLAIN_EMAIL = 'REQUESTED_PLAIN_EMAIL';
export const RECEIVED_PLAIN_EMAIL = 'RECEIVED_PLAIN_EMAIL';
export const REQUESTED_PLAIN_EMAIL_FAILED = 'REQUESTED_PLAIN_EMAIL_FAILED';
export const SAVE_EMAIL = 'SAVE_EMAIL';
export const SAVE_EMAIL_FAILED = 'SAVE_EMAIL_FAILED';
export const DELETE_EMAIL = 'DELETE_EMAIL';
export const DELETE_EMAIL_FAILED = 'DELETE_EMAIL_FAILED';
export const REQUESTED_EMAILS = 'REQUESTED_EMAILS';
export const RECEIVED_EMAILS = 'RECEIVED_EMAILS';
export const REQUESTED_EMAILS_FAILED = 'REQUESTED_EMAILS_FAILED';